import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { OverviewTab } from "@/components/software-updates/OverviewTab";
import { PoliciesTab } from "@/components/software-updates/PoliciesTab";
import { DevicesTab } from "@/components/software-updates/DevicesTab";
import { VersionsTab } from "@/components/software-updates/VersionsTab";
import { SettingsTab } from "@/components/software-updates/SettingsTab";

const TABS = ["overview", "policies", "versions", "devices", "settings"] as const;
type TabId = (typeof TABS)[number];

export default function SoftwareUpdatesPage() {
  const [params, setParams] = useSearchParams();
  const raw = params.get("tab");
  const active: TabId = (TABS.includes(raw as TabId) ? raw : "overview") as TabId;

  const setTab = (next: string) => {
    const sp = new URLSearchParams(params);
    sp.set("tab", next);
    setParams(sp, { replace: true });
  };

  return (
    <div className="px-6 py-6 space-y-6">
      <header className="space-y-1">
        <h1 className="text-2xl font-semibold tracking-tight">Software Updates</h1>
        <p className="text-sm text-muted-foreground">
          Monitor and enforce Apple OS updates across your fleet.
        </p>
      </header>

      <Tabs value={active} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="overview">Overview</TabsTrigger>
          <TabsTrigger value="policies">Policies</TabsTrigger>
          <TabsTrigger value="versions">Versions</TabsTrigger>
          <TabsTrigger value="devices">Devices</TabsTrigger>
          <TabsTrigger value="settings">Settings</TabsTrigger>
        </TabsList>
        <TabsContent value="overview" className="mt-6">
          <OverviewTab />
        </TabsContent>
        <TabsContent value="policies" className="mt-6">
          <PoliciesTab />
        </TabsContent>
        <TabsContent value="versions" className="mt-6">
          <VersionsTab />
        </TabsContent>
        <TabsContent value="devices" className="mt-6">
          <DevicesTab />
        </TabsContent>
        <TabsContent value="settings" className="mt-6">
          <SettingsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
